import { format, isValid, parseISO } from 'date-fns'
import type { Loan, LoanType, RecalculatedLoan } from '../types/comp'

export function formatDate(iso: string): string {
  if (!iso) return '—'
  const parsed = parseISO(iso)
  return isValid(parsed) ? format(parsed, 'MMM d, yyyy') : '—'
}

export function formatCurrency(value: number): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })
}

export function formatSigned(value: number): string {
  const sign = value > 0 ? '+' : value < 0 ? '−' : ''
  return `${sign}${formatCurrency(Math.abs(value))}`
}

/** Short loans earn a percentage of the standard bps rate. */
export function effectiveBps(bps: number, shortPct: number, loanType: LoanType): number {
  return loanType === 'full' ? bps : (bps * shortPct) / 100
}

export function commissionFor(loan: Loan, bps: number, shortPct: number): number {
  return Math.round((loan.amount * effectiveBps(bps, shortPct, loan.loanType)) / 10000)
}

export function loansInRange(loans: Loan[], from: string, to: string): Loan[] {
  return loans
    .filter((loan) => (!from || loan.fundedDate >= from) && (!to || loan.fundedDate <= to))
    .sort((a, b) => a.fundedDate.localeCompare(b.fundedDate))
}

export function recalculate(
  loans: Loan[],
  bps: number,
  shortPct: number,
): RecalculatedLoan[] {
  return loans.map((loan) => {
    const newCommission = commissionFor(loan, bps, shortPct)
    return {
      ...loan,
      newCommission,
      difference: newCommission - loan.currentCommission,
    }
  })
}
